import { Stack } from "@mui/material";
import CardChip, { CardChipProps } from "@/components/common/chips/cardChip";
import { MoxieImage } from "@/components/common/images/moxieImage";

type CardThumbnailProps = {
  url: string;
  alt?: string;
  height: number | string;
  chips?: CardChipProps[];
  isMobile: boolean;
};

export default function CardThumbnail({
  url,
  alt,
  height,
  chips,
  isMobile,
}: CardThumbnailProps) {
  return (
    <Stack
      sx={{
        position: "relative",
      }}
    >
      <MoxieImage
        imageUrl={url}
        height={height}
        alt={alt ?? "Card thumbnail"}
        style={{
          borderRadius: "8px",
        }}
      />
      <Stack
        sx={{
          alignItems: "flex-start",
          gap: 1,
          padding: 1,
          position: "absolute",
          top: 0,
          left: 0,
        }}
      >
        {chips?.map(({ label, textColor, backgroundColor, sx }) => (
          <CardChip
            key={label}
            label={label}
            textColor={textColor}
            backgroundColor={backgroundColor}
            size={isMobile ? "medium" : "small"}
            sx={sx}
          />
        ))}
      </Stack>
    </Stack>
  );
}
